import { render, staticRenderFns } from "./createEditOpenDays.vue?vue&type=template&id=9287e9d0"
import script from "./createEditOpenDays.js?vue&type=script&lang=js&external"
export * from "./createEditOpenDays.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports